/**
 * Module definition and dependencies
 */
angular.module('Crm.HistoriquesContact.Controller', ['programmesService.Service', 'contactsService.Service', 'ngMessages'])
/**
 * Controller
 */
.controller('HistoriquesContactCtrl', ['ContactHistorique', '$rootScope', '$q', 'Programme', function (ContactHistorique, $rootScope, $q, Programme) {
  const limitPage = 4;
  let page = 0;
  this.historiques = [];
  this.nombreResultat;
  this.loadingPromise = $q.resolve();
  this.loading = false;
  this.allLoaded = false;

  this.getListHistoriques = () => {
    return this.loadingPromise = this.loadingPromise.then(() => {
      if (this.nombreResultat && this.nombreResultat <= this.historiques.length || this.nombreResultat === 0) {
        this.allLoaded = true;
        return $q.resolve();
      }

      this.loading = true;
      page++;
      const query = {
        limit: limitPage,
        page: page,
        contactId: this.contact.id
      }; //Param pour ADV

      if ($rootScope.env && $rootScope.env === "immodesk") {
        query.adv = true;
      }

      return ContactHistorique.query(query).$promise.then(response => {
        this.nombreResultat = response.total;
        angular.forEach(response.data, value => {
          if (value.programme_id) {
            Programme.get({
              programmeId: value.programme_id
            }).$promise.then(response => {
              value.programme = response;
            }).catch(error => {
              console.log(error);
            });
          }

          this.historiques.push(value);
        });
      });
    }).then(() => {
      this.loading = false;
    }).catch(error => {
      console.log(error);
    });
  };

  $rootScope.$on('newAction', (evt, data) => {
    if (data.contact.id !== this.contact.id) {
      return;
    }

    this.historiques.unshift(data.action);
  });
}]);
/**
 * Module definition and dependencies
 */

angular.module('Crm.HistoriquesContact', ['Crm.HistoriquesContact.Controller', "Crm.historiques-contact.templates"]).component('historiquesContact', {
  controller: 'HistoriquesContactCtrl',
  templateUrl: 'src/historiques-contact/historiques-contact.html',
  bindings: {
    contact: '<'
  }
});
angular.module('Crm.historiques-contact.templates', []).run(['$templateCache', function($templateCache) {$templateCache.put('src/historiques-contact/historiques-contact.html','<div class="scroll-historique"><ul ng-class="{timeline: $ctrl.historiques.length > 0, unstyled: $ctrl.historiques.length === 0}" infinite-scroll="$ctrl.getListHistoriques()" infinite-scroll-use-document-bottom="true"><li ng-repeat="item in $ctrl.historiques" ng-class="{true: \'timeline-inverted\'}[$odd]"><div class="timeline-badge" uib-tooltip="{{ item.emetteur_prenom }}&nbsp;{{ item.emetteur_nom }}" tooltip-placement="top"> <img src="{{ item.emetteur_image }}" ng-if="item.emetteur_image"/> <i class="material-icons profil-icon" ng-if="!item.emetteur_image">person</i></div><div class="timeline-panel"><div class="timeline-heading"><div class="timeline-time"><i class="glyphicon glyphicon-time"></i> {{ item.date_last_update.date | moment: \'DD/MM/YYYY HH:mm\' }} <span ng-if="item.done === \'0\'" class="label label-danger">A traiter</span> <span ng-if="item.done === \'1\'" class="label label-success">R\xE9alis\xE9e</span></div><div class="timeline-title" ng-if="item.date_echeance"> \xC9ch\xE9ance : {{ item.date_echeance.date | moment: \'DD/MM/YYYY\' }}</div><div class="timeline-title" ng-if="item.membre_rdv_prenom && item.membre_rdv_nom"> Vendeur : {{ item.membre_rdv_prenom }}&nbsp;{{ item.membre_rdv_nom }}</div><div class="timeline-title mt-1" ng-if="item.texte"> {{ item.emetteur_prenom }}&nbsp;{{ item.emetteur_nom }} :</div> <span class="type-label label label-success">{{ item.type_label }}</span></div><div class="timeline-body" ng-if="item.texte"><p class="bold mt-05" ng-bind-html="item.titre" ng-if="item.titre"></p><p class="mt-05" ng-if="item.programme">Programme : {{ item.programme.nom }}</p><p ng-bind-html="item.texte"></p></div><div ng-if="item.type_id === 23 || item.type_id === 29 || item.type_id === 34" class="pull-right"><div ng-if="item.is_read"> <span class="badge">Lu le {{ item.date_read.date | moment: \'DD/MM/YYYY\' }}</span></div><div ng-if="!item.is_read" class="pull-right"><span class="badge">Non lu</span></div></div></div></li><li ng-if="$ctrl.historiques.length === 0 && !$ctrl.loading" class="txt-center"><p>Aucun historique pour ce contact</p></li></ul></div><div class="scroll-footer" style="text-align:center;"> <span ng-show="!$ctrl.allLoaded && $ctrl.loading">En chargement&nbsp;&nbsp;&nbsp;<img ng-src="{{$root.pathImageAjaxLoader}}"/></span> <span ng-show="$ctrl.allLoaded && !$ctrl.loading">Pas d\'historique suppl\xE9mentaire</span></div>');}]);